<template>
  <div class="modal">
    <div class="modal__container">
      <div class="modal__container-left">
        <h1 class="modal__header">Error</h1>
        <div class="modal__content">
          <ul class="modal__list">
            <li>{{ currentFile.errorMessage }}</li>
          </ul>
        </div>
        <div class="modal-btn__container single">
          <v-btn
            class="modal-btn"
            :color="'#CB201F'"
            outlined
            @click="downloadDocument(currentFile.attachmentId)"
          >Download</v-btn>
        </div>
      </div>
      <div class="modal__container-right">
        <h1 class="modal__header">New Upload</h1>
        <div class="modal__content">
          <div class="modal__upload-container">
            <v-icon class="paperclip-icon" large>mdi-paperclip</v-icon>
            <v-file-input
              @change="handleFileUpload"
              label="Select a new file"
              :show-size="1000"
              solo
              prepend-icon
              outlined
              flat
              truncate-length="23"
            />
          </div>
        </div>
        <div class="divider"></div>
        <div class="modal-btn__container">
          <v-btn class="elevation-0 modal-btn cancel" :color="'#DEDEDE'" @click="close()">Cancel</v-btn>
          <v-btn
            class="elevation-0 modal-btn confirm"
            :color="'#CB201F'"
            :disabled="!file"
            @click="submitFile()"
          >Confirm</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '../services/API';

export default {
  name: 'File-Upload-Modal',
  props: ['currentFile'],
  data() {
    return {
      file: '',
      progressPercentage: 0,
    };
  },
  methods: {
    handleFileUpload: function(file) {
      this.file = file;
    },
    submitFile: function() {
      const form = new FormData();
      form.append('file', this.file);

      API.post('/documents/resubmit/' + this.currentFile.uuid, form, {
        onUploadProgress: (progressEvent) => {
          this.$emit('startUpload');
          this.progressPercentage = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
          );
          this.close();
          this.$emit('percentage', this.progressPercentage);
          if (this.progressPercentage >= 100) {
            this.$emit('completed');
          }
        },
      }).catch((err) => {
        this.close();
        console.error(err);
      });
    },
    downloadDocument(attachmentId) {
      console.log(attachmentId);
      API.get(`documents/excel/${attachmentId}`).then((attachment) => {
        console.log(attachment);
        window.open(attachment.data.url, '_blank');
      });
    },
    close: function() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed; /* Sit on top of the page content */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 100; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */

  display: flex;
  justify-content: center;
  align-items: center;

  &__container {
    background: #fff;
    color: #000;
    height: 437px;
    width: 720px;
    border-radius: 6px;

    & > * {
      height: 100%;
      width: 50%;
      float: left;
    }

    &-left {
      background-color: #dedede;
      border-bottom-left-radius: 6px;
      border-top-left-radius: 6px;
    }

    &-right {
      border-bottom-right-radius: 6px;
      border-top-right-radius: 6px;
    }
  }

  h1,
  p {
    color: #212121 !important;
    font-family: Heebo;
    line-height: 2.1rem;
    letter-spacing: 0.124rem;
  }

  &__header {
    padding: 55px 0;
    width: 100%;
    color: #212121;
    font-family: Heebo;
    font-size: 32px;
    font-weight: bold;
    line-height: 47px;
    text-align: center;
    vertical-align: center;
  }

  &__text {
    text-align: center;
    padding: 0 0 1rem 0;
    font-size: 1.2rem;
  }

  &__content {
    width: 100%;
    height: 182px;
    padding: 0 30px;
    overflow-x: auto;
  }

  &__list {
    height: 27px;
    width: 286px;
    padding-top: 14px;
    color: #212121;
    font-family: Heebo;
    font-size: 18px;
    line-height: 27px;
  }

  &__upload-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .paperclip-icon {
      padding: 0 5px 28px 0;
    }
  }

  .divider {
    width: 30rem;
    height: 0.1rem;
    border-bottom: 2px solid #dedede;
    margin: 0.5rem auto;
  }

  .modal-btn {
    font-family: Heebo;
    letter-spacing: 0.5px;
    font-size: 1.5rem;
    line-height: 24px;
    text-align: center;
    text-transform: none;
    width: 120px;

    &__container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 35px 40px;

      &.single {
        margin-top: 11px;
        justify-content: center;
      }
    }

    &.confirm {
      color: #fff;
    }
  }
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: rgb(203, 32, 31, 0.5) !important;
  color: #fff !important;
}
</style>

